import { INDEX_PAGE_URL, SOCIAL_NETWORK_PAGE_URL } from '@/api/core/links';
import { SOCIAL_NETWORK_MOCK_ENABLED } from './featureFlags';

export const SYSTEM_HOME_PAGE_URL = SOCIAL_NETWORK_MOCK_ENABLED ? SOCIAL_NETWORK_PAGE_URL : INDEX_PAGE_URL;
